//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import LinkBtn from '../../../components/LinkBtn.vue'
import ReadonlyDocumentsField from '../../../components/File/ReadonlyDocumentsField.vue'
import { settingsGUI } from '../../../pages/main/sections/UserSettings/UserSettingsGUI.js'
import { axiosPost } from '../../../axios/axios.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    LinkBtn,
    ReadonlyDocumentsField
  },
  mixins: [settingsGUI],
  props: {
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObjectType: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      images: [],
      imagesExpanded: false,

      priorities: [
        { value: 1, label: 'Обычный' },
        { value: 2, label: 'Приоритетный' },
        { value: 3, label: 'Высокоприоритетный' }
      ],

      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    deviceIpHref: function () {
      if (this.serviceObject.deviceIp && this.serviceObject.deviceIp !== 'Нет данных') {
        return 'https://' + this.serviceObject.deviceIp.split(', ')[0]
      }
      return null
    },
    validSubPriority: function () {
      return Number.isInteger(this.serviceObject.subPriority) && this.serviceObject.subPriority >= 1 && this.serviceObject.subPriority <= 100
    },
    externalDispatcherBounded: function () {
      const user = this.$store.getters.getUser
      return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    },
    hasEditAccess: function () {
      return !this.user.externalCurator && !this.externalDispatcherBounded // TODO access
    }
  },
  watch: {
    serviceObject: function () {
      this.prepareImages()
    }
  },
  created: function () {
    this.prepareImages()
  },
  methods: {
    openIpAddress: function () {
      if (this.serviceObject.deviceIp && this.serviceObject.deviceIp !== 'Нет данных') {
        window.open('http://' + this.serviceObject.deviceIp.split(', ')[0])
      }
    },
    prepareImages: function () {
      const images = []
      if (this.serviceObject.lastRequestReportDocuments != null) {
        for (const document of this.serviceObject.lastRequestReportDocuments) {
          if (this.isImage(document.contentType)) {
            images.push({
              id: document.id,
              name: this.serviceObject.name + '-' + (images.length + 1) + '.' + document.contentType.split('/')[1]
            })
          }
        }
      }
      this.images = images
    },
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    },
    onSave: function () {
      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('id', this.serviceObject.id)
      bodyFormData.set('priority', this.serviceObject.priority)
      bodyFormData.set('subPriority', this.serviceObject.subPriority)

      axiosPost({
        url: '/service/delta/serviceobject/save',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Данные по объекту обслуживания успешно изменены',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка сохранения данных по объекту обслуживания',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

